module.exports = "@media screen and (max-width: 640px) {\n   p{\n       font-size: 11px !important;\n       margin: 6px 0 10px !important;\n   }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/playlist-duration/playlist-duration.component.css
// module id = ./src/app/shared/playlist-duration/playlist-duration.component.css
// module chunks = main